import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Container,
  Button,
  FormGroup,
  Alert,
  Image,
} from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, isNumber } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import "jspdf-autotable";
import Swal from "sweetalert";
import { addCustomer } from "./Customer.action";
import { setHeading } from "../../../accounts/account.actions";
const AddCustomer = (props) => {
  const [customer, setCustomer] = useState("");
  const [customerCnic, setCustomerCnic] = useState();
  const [customerPhone, setCustomerPhone] = useState(0);
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerAddress2, setCustomerAddress2] = useState("");
  const [customerAddress3, setCustomerAddress3] = useState("");
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

  const handleVisible = (msg) => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: msg,
      icon: "success",
      button: "Ok",
    });
  };

  const handleDangerVisible = (err) => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: err,
      icon: "error",
      button: "Ok",
    });
  };

  function uploadCustomer() {
    props.addCustomer(
      {
        name: customer,
        phone: customerPhone,
        address: customerAddress,
        address2: customerAddress2,
        address3: customerAddress3,
        email: customerCnic,
      },
      handleVisible,
      handleDangerVisible
    );
  }
  useEffect(() => {
    props.setHeading("Add Customer");
  }, []);
  return (
    <>
      {props.isAddingCustomer ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="grow"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <div>
              <Form>
                <Row>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Customer Name *</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Customer Name...."
                        onChange={(e) => setCustomer(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Customer Phone *</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Customer Phone...."
                        value={customerPhone}
                        onChange={(e) => {
                          !isNaN(e.target.value) &&
                            setCustomerPhone(e.target.value);
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Customer Email </b>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Customer Email...."
                        onChange={(e) => {
                          setCustomerCnic(e.target.value);
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Customer Address 1 *</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={customerAddress}
                        placeholder="Customer Address...."
                        onChange={(e) => setCustomerAddress(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Customer Address 2</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={customerAddress2}
                        placeholder="Customer Address...."
                        onChange={(e) => setCustomerAddress2(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Customer Address 3</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={customerAddress3}
                        placeholder="Customer Address...."
                        onChange={(e) => setCustomerAddress3(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="sendDiv">
                  {isEmpty(customer) ||
                  isEmpty(customerPhone) ||
                  isEmpty(customerAddress) ? (
                    <Button
                      disabled
                      style={{
                        marginLeft: "2%",
                        color: "white",
                        width: "20%",
                        backgroundColor: "#1976d2",
                        border: "1px solid #1976d2",
                      }}
                    >
                      Save
                    </Button>
                  ) : (
                    <Button onClick={uploadCustomer}>Save</Button>
                  )}
                </div>
              </Form>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCustomer: (data, handleVisible, handleDangerVisible) =>
      dispatch(addCustomer(data, handleVisible, handleDangerVisible)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  customerList: state.CustomerReducer.customerList,
  isAddingCustomer: state.CustomerReducer.isAddingCustomer,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCustomer);
